export enum SessionPassiveLoginListenerStrategy {
  NATIVE = 'native',
  POLLING = 'polling',
}

export interface SessionPassiveLoginListenerConfig {
  strategy?: SessionPassiveLoginListenerStrategy;
}

export interface SessionPassiveLoginListenerInterface {
  init: () => Promise<void>;
  close: () => void;
}

export type PassiveLoginStrategyInterface = SessionPassiveLoginListenerInterface;
